import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-17c2bd92"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  ref: "container",
  class: "seasonal-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "seasonal-months"
}, "Months", -1));
const _hoisted_3 = {
  class: "seasonal-month"
};
const _hoisted_4 = {
  class: "seasonal-values"
};
const _hoisted_5 = {
  key: 0,
  class: "seasonal-values-grid"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_slider = _resolveComponent("app-slider");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.monthlyKeys, (key, i) => {
    return _openBlock(), _createElementBlock("div", {
      key: key,
      class: "seasonal-row"
    }, [_createElementVNode("div", _hoisted_3, _toDisplayString(key), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_app_slider, {
      modelValue: $data.current[key],
      "onUpdate:modelValue": $event => $data.current[key] = $event,
      options: $props.percents,
      "padding-top": 0,
      "show-steps": false,
      variant: "custom",
      mixed: "",
      onChange: $options.onChange
    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"]), i < Object.keys($data.current).length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.percents, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: item.value,
        class: _normalizeClass(['seasonal-values-item', {
          active: index == $props.percents.findIndex(item => item.start)
        }, {
          intermediary: !item.label
        }])
      }, null, 2);
    }), 128))])) : _createCommentVNode("", true)])]);
  }), 128))], 512);
}